import { useState } from 'react';

import CrossIcon from '@/assets/cross.svg?react';

import { useAutoAnimate } from '@formkit/auto-animate/react';

const InfoToggle = ({ info }: { info: string }) => {
  const [parent] = useAutoAnimate({
    duration: 200,
  });

  const [visible, setVisible] = useState(true);

  return (
    <div ref={parent}>
      {visible && (
        <div className="caption mt-2 flex justify-between rounded-md bg-blue-500 px-2.5 py-2 text-gray-100">
          {info}
          <button
            type="button"
            onClick={() => setVisible(false)}
            className="flex-none text-white transition-colors hover:text-gray-300"
            aria-label="close-info"
          >
            <CrossIcon width={14} />
          </button>
        </div>
      )}
    </div>
  );
};

export default InfoToggle;
